import JwtService from "@/core/services/jwt.service";

export default class UploadAdapter {
  constructor(loader, fileCategory) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.fileCategoory = fileCategory;
  }

  // Starts the upload process.
  upload() {
    return this.loader.file.then(
      file =>
        new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        })
    );
  }

  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    xhr.open(
      "POST",
      `${process.env.VUE_APP_SERVER_URL}/file/upload/${this.fileCategoory}`,
      true
    );
    xhr.responseType = "json";
    xhr.setRequestHeader("Authorization", `Bearer ${JwtService.getToken()}`);
    xhr.withCredentials = true;
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // if (response) {
      //   fetch(response.url)
      //     .then(async res => await res.blob())
      //     .then(async fl => {
      //       fl.name = response.name;
      //     })
      //     .then(res =>
      //       resolve({
      //         default: res.url
      //       })
      //     );
      // }
      //
      resolve({
        default: response.url
      });
    });

    if (xhr.upload) {
      xhr.upload.addEventListener("progress", evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();

    data.append("file", file);

    // Send the request.
    this.xhr.send(data);
  }
}
